import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  ReactiveFormsModule
} from '@angular/forms';
import { ColDef, GridOptions } from 'ag-grid-community';
import { CustomerNamePipe } from '../../shared/pipes/customer-name.pipe';
import { CustomerNameCellComponent } from '../../shared/ag-grid-cells/customer-name-cell.component';
import { DocketNumberAccountReferenceCellComponent } from '../../shared/ag-grid-cells/docket-number-account-reference-cell.component';
import { DateFormatPipe } from 'ngx-moment';
import { ConfigService } from '../../shared/services/config.service';
import { XeroJobDataSource } from '../../shared/helpers/XeroJobDataSource';
import { XeroService } from '../../shared/services/xero.service';
import { DOCUMENT, NgStyle } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { MatButton } from '@angular/material/button';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker
} from '@angular/material/datepicker';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import {
  MatFormField,
  MatLabel,
  MatSuffix
} from '@angular/material/form-field';

@Component({
  selector: 'app-report',
  templateUrl: './xero-report.component.html',
  styleUrls: ['./xero-report.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [XeroService, DateFormatPipe, CustomerNamePipe],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatButton,
    AgGridModule,
    NgStyle,
    ExtendedModule
  ]
})
export class XeroReportComponent implements OnInit {
  columns: ColDef[] = [];

  gridOptions: GridOptions = {
    rowModelType: 'infinite',
    paginationPageSize: 500,
    cacheBlockSize: 500,
    headerHeight: 45,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 2,
    infiniteInitialRowCount: 1,
    enableCellTextSelection: true,
    isRowSelectable: () => false
  };
  height = 400;

  @ViewChild('agGrid') grid!: AgGridAngular;

  reportForm = new UntypedFormGroup({
    type: new UntypedFormControl(null),
    status: new UntypedFormControl(null),
    from: new UntypedFormControl(null),
    to: new UntypedFormControl(null)
  });

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private xeroService: XeroService,
    private datePipe: DateFormatPipe
  ) {}

  ngOnInit() {
    this.columns = <ColDef[]>[
      {
        headerName: 'Contract',
        cellRenderer: DocketNumberAccountReferenceCellComponent,
        resizable: true,
        filter: false,
        valueGetter: (params) => {
          if (!params.data) {
            return null;
          }
          if (
            ['Hire Invoice', 'Sale Invoice', 'Repair Invoice'].includes(
              params.data.type
            )
          ) {
            return params.data.docket;
          }
          if (params.data.type === 'Payment') {
            return {
              id: params.data.payment.docket_id,
              account_reference: params.data.payment.invoice_number
            };
          }
          return null;
        }
      },
      {
        headerName: 'Customer',
        cellRenderer: CustomerNameCellComponent,
        resizable: true,
        filter: false,
        valueGetter: (params) => {
          if (!params.data) {
            return null;
          }
          return params.data.customer;
        },
        sort: true
      },
      {
        filter: false,
        headerName: 'Type',
        field: 'type'
      },
      {
        filter: false,
        headerName: 'Status',
        resizable: true,
        field: 'status'
      },
      {
        filter: false,
        headerName: 'Response',
        resizable: true,
        field: 'xero_error'
      },
      {
        headerName: 'Transfer Date',
        filter: false,
        field: 'transferred_at',
        resizable: true,
        valueGetter: (params) => {
          if (params.data) {
            return this.datePipe.transform(
              params.data['transferred_at'],
              ConfigService.dates.shortDateTimeFormat
            );
          }
        }
      },
      {
        headerName: 'Created Date',
        filter: false,
        field: 'created_at',
        valueGetter: (params) => {
          if (params.data) {
            return this.datePipe.transform(
              params.data['created_at'],
              ConfigService.dates.shortDateTimeFormat
            );
          }
        }
      }
    ];
  }

  getXeroJobs() {
    const dataSource = new XeroJobDataSource(
      this.xeroService,
      this.reportForm.value
    );
    this.grid.api.setGridOption('datasource', dataSource);
  }
}
